import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Guard, Result } from '@digibricks/core';
import { Duration, Expectation, UnixTimestamp } from '../../../../domain';
import { CreateAssignmentUseCase } from '../create-assignment.usecase';
import { InvalidPracticeAssignmentExpectationError } from './create-practice-assignment.error';
import { InvalidDurationError } from '../create-assignment.error';
export var CREATE_PRACTICE_ASSIGNMENT_USE_CASE = 'CREATE_PRACTICE_ASSIGNMENT_USE_CASE';
export var CreatePracticeAssignmentUseCase = /*#__PURE__*/function (_CreateAssignmentUseC) {
  _inherits(CreatePracticeAssignmentUseCase, _CreateAssignmentUseC);

  var _super = _createSuper(CreatePracticeAssignmentUseCase);

  function CreatePracticeAssignmentUseCase(practiceAssignmentRepository, formReleaseRepository) {
    var _this;

    _classCallCheck(this, CreatePracticeAssignmentUseCase);

    _this = _super.call(this, formReleaseRepository);
    _this.practiceAssignmentRepository = practiceAssignmentRepository;
    _this.formReleaseRepository = formReleaseRepository;
    return _this;
  }

  _createClass(CreatePracticeAssignmentUseCase, [{
    key: "validate",
    value: function validate(input) {
      var expectation = input.expectation;
      var collection = [{
        argument: input.duration,
        argumentName: 'Duration'
      }, {
        argument: input.isShowingExplanationAndCorrectAnswers,
        argumentName: 'Is Showing Explanation And Correct Answers'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(collection);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      if (!Duration.isValid(input.duration)) {
        return new InvalidDurationError();
      }

      if (expectation && !Expectation.isValid(expectation)) {
        return new InvalidPracticeAssignmentExpectationError();
      }

      return Result.ok();
    }
  }, {
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var validatedBasePropsOrError, validatedOwnInputOrError, baseInputOrError, useCaseInput, startTimeInMillisecond, endTimeInMillisecond;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                validatedBasePropsOrError = _get(_getPrototypeOf(CreatePracticeAssignmentUseCase.prototype), "validateBaseInput", this).call(this, input);

                if (!validatedBasePropsOrError.isFailure) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", Result.fail(validatedBasePropsOrError.error));

              case 3:
                validatedOwnInputOrError = this.validate(input);

                if (!validatedOwnInputOrError.isFailure) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", Result.fail(validatedOwnInputOrError.error));

              case 6:
                _context.next = 8;
                return _get(_getPrototypeOf(CreatePracticeAssignmentUseCase.prototype), "createBaseInput", this).call(this, input);

              case 8:
                baseInputOrError = _context.sent;

                if (!baseInputOrError.isFailure) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("return", Result.fail(baseInputOrError.error));

              case 11:
                useCaseInput = _objectSpread(_objectSpread(_objectSpread({}, input), baseInputOrError.getValue()), {}, {
                  startTime: input.startTime ? UnixTimestamp.floorToNearestMinute(input.startTime) : undefined,
                  endTime: input.endTime ? UnixTimestamp.floorToNearestMinute(input.endTime) : undefined
                });

                if (input.startTime) {
                  startTimeInMillisecond = UnixTimestamp.isInSecondType(input.startTime) ? UnixTimestamp.toMillisecond(input.startTime) : input.startTime;
                  useCaseInput.startTime = UnixTimestamp.floorToNearestMinute(startTimeInMillisecond);
                }

                if (input.endTime) {
                  endTimeInMillisecond = UnixTimestamp.isInSecondType(input.endTime) ? UnixTimestamp.toMillisecond(input.endTime) : input.endTime;
                  useCaseInput.endTime = UnixTimestamp.floorToNearestMinute(endTimeInMillisecond);
                }

                return _context.abrupt("return", this.practiceAssignmentRepository.create(useCaseInput));

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return CreatePracticeAssignmentUseCase;
}(CreateAssignmentUseCase);